import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import {
  AppQueryProvider,
  ApplicationErrorBoundary,
  AuthProvider,
  PermissionProvider,
  ToastProvider,
} from '@beatq/shared';
import { ThemeProvider } from '@beatq/ui';
import '@beatq/ui/styles.css';
import './console.css';
import './admin-design.css';
import { App } from './App.js';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ApplicationErrorBoundary appName="BeatQ Admin" homeHref="/">
      <div className="admin-console min-h-screen">
        <AppQueryProvider>
          <AuthProvider surface="admin">
            <PermissionProvider surface="admin">
              <ThemeProvider>
                <ToastProvider connectivityToasts={false}>
                  <BrowserRouter>
                    <App />
                  </BrowserRouter>
                </ToastProvider>
              </ThemeProvider>
            </PermissionProvider>
          </AuthProvider>
        </AppQueryProvider>
      </div>
    </ApplicationErrorBoundary>
  </StrictMode>,
);
